import { AxiosRequest } from "../common/axios-request";
import { BookingUser, CourtBookingDataType } from "../../types";
import {
  BOOKED_COURT_DETAILS,
  CANCEL_COURT_BOOKING,
  COURT_BOOKING_AMOUNT,
  COURT_BOOKING_COLLECT_CASH,
  COURT_BOOKING_LIST,
  COURT_BOOKING_REFUND,
  COURT_BOOKING_SHARE_PAYMENT_LINK,
  CREATE_COURT_BOOKING,
  CREATE_COURT_BOOKING_END_USER,
  CUSTOMER_COURT_BOOKING_AMOUNT,
  CUSTOMER_COURT_BOOKING_RESCHEDULE,
  CUSTOMER_COURT_BOOKING_RESCHEDULE_AMOUNT,
  DOWNLOAD_COURT_BOOKING_RECORD,
  GET_COURT_BOOKING_INVOICE,
  RESCHEDULE_AMOUNT,
  RESCHEDULE_COURT_BOOKING,
  SEND_OTP_BOOKING,
  VALIDATE_BOOKING_USER,
  GET_COURT_BOOKING_SUMMARY,
  GET_PDF_HTML_FOR_PRINT_API,
} from "../common/constant";

const CreateCourtBooking = (payload: CourtBookingDataType) => {
  return AxiosRequest.post(CREATE_COURT_BOOKING, payload);
};

const ValidateBookingUser = (payload: BookingUser) => {
  return AxiosRequest.post(VALIDATE_BOOKING_USER, payload);
};

const CourtBookingAmount = (payload: any) => {
  return AxiosRequest.post(COURT_BOOKING_AMOUNT, payload);
};

const SendOtpBooking = (payload: any) => {
  return AxiosRequest.post(SEND_OTP_BOOKING, payload);
};

const GetCourtBookingList = (data: any) => {
  const {
    page,
    key,
    fromDate,
    toDate,
    facilityId,
    sportName,
    courtName,
    bookingType,
    bookingStatus,
    paymentStatus,
    paymentMode,
    paymentMethod,
    orderByCol,
    orderBy,
    situationType,
  } = data;
  return AxiosRequest.get(
    COURT_BOOKING_LIST(
      page,
      key,
      fromDate,
      toDate,
      facilityId,
      sportName,
      courtName,
      bookingType,
      bookingStatus,
      paymentStatus,
      paymentMode,
      paymentMethod,
      orderByCol,
      orderBy,
      situationType
    )
  );
};

const GetBookedCourtDetail = (id: string) => {
  return AxiosRequest.get(BOOKED_COURT_DETAILS(id));
};

const CancelCourtBooking = (id: string, payload: any) => {
  return AxiosRequest.put(CANCEL_COURT_BOOKING(id), payload);
};

const rescheduleCourtBookingApi = (id: string, payload: any) => {
  return AxiosRequest.put(RESCHEDULE_COURT_BOOKING(id), payload);
};

const rescheduleAmount = (id: string, payload: object) => {
  return AxiosRequest.post(RESCHEDULE_AMOUNT(id), payload);
};

const GetCourtBookingInvoice = (id: string) => {
  return AxiosRequest.get(GET_COURT_BOOKING_INVOICE(id));
};
const GetCourtBookingSummaryPrint = (id: string) => {
  return AxiosRequest.get(GET_COURT_BOOKING_SUMMARY(id));
};

const CollectCash = (id: string, payload: any) => {
  return AxiosRequest.put(COURT_BOOKING_COLLECT_CASH(id), payload);
};

const BookingRefund = (id: string, payload: any) => {
  return AxiosRequest.put(COURT_BOOKING_REFUND(id), payload);
};

const GetPdfHtmlForPrint = (type: string, hash: string) => {
  return AxiosRequest.get(GET_PDF_HTML_FOR_PRINT_API(type, hash));
};
const DownloadCourtBookingReport = (params: any) => {
  const {
    key,
    fromDate,
    toDate,
    facilityId,
    sportName,
    courtName,
    bookingType,
    bookingStatus,
    paymentStatus,
    paymentMode,
    paymentMethod,
    orderByCol,
    orderBy,
  } = params;
  return AxiosRequest.get(
    DOWNLOAD_COURT_BOOKING_RECORD(
      key,
      fromDate,
      toDate,
      facilityId,
      sportName,
      courtName,
      bookingType,
      bookingStatus,
      paymentStatus,
      paymentMode,
      paymentMethod,
      orderByCol,
      orderBy
    )
  );
};

const CustomerCourtBookingAmount = (payload: any) => {
  return AxiosRequest.post(CUSTOMER_COURT_BOOKING_AMOUNT, payload);
};

const CreateCourtBookingEndUser = (payload: any) => {
  return AxiosRequest.post(CREATE_COURT_BOOKING_END_USER, payload);
};

const CustomerCourtBookingRescheduleAmount = (id: string, payload: any) => {
  return AxiosRequest.post(
    CUSTOMER_COURT_BOOKING_RESCHEDULE_AMOUNT(id),
    payload
  );
};

const CustomerCourtBookingRescheduling = (id: string, payload: any) => {
  return AxiosRequest.put(CUSTOMER_COURT_BOOKING_RESCHEDULE(id), payload);
};

const CourtBookingSharePaymentLink = (id: string) => {
  return AxiosRequest.put(COURT_BOOKING_SHARE_PAYMENT_LINK(id), null);
};

export {
  GetCourtBookingInvoice,
  CreateCourtBooking,
  ValidateBookingUser,
  CourtBookingAmount,
  SendOtpBooking,
  GetCourtBookingList,
  GetBookedCourtDetail,
  CancelCourtBooking,
  rescheduleCourtBookingApi,
  rescheduleAmount,
  CollectCash,
  BookingRefund,
  DownloadCourtBookingReport,
  CustomerCourtBookingAmount,
  CreateCourtBookingEndUser,
  CustomerCourtBookingRescheduleAmount,
  CustomerCourtBookingRescheduling,
  CourtBookingSharePaymentLink,
  GetCourtBookingSummaryPrint,
  GetPdfHtmlForPrint,
};
